import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';

const useStyles = makeStyles({
  img: {
    display: 'block',
    maxHeight: '50px'
  }
});

export const ImagePreview = ({ field, image }) => {
  const classes = useStyles();
  const uri = image && image.uri;
  return uri
    ? <img data-testid={`image-preview-${field}`} className={classes.img} src={uri} />
    : <Translate content='pdf_editor_option_default_content_empty_text' />;
};

ImagePreview.propTypes = {
  image: PropTypes.object
};

export default React.memo(ImagePreview);
